module.exports = __webpack_public_path__ + "static/media/icon-comm-form.95df2b7f.svg";